import { render, staticRenderFns } from "./AgreementRenderer.vue?vue&type=template&id=4e265570&scoped=true&"
import script from "./AgreementRenderer.vue?vue&type=script&lang=js&"
export * from "./AgreementRenderer.vue?vue&type=script&lang=js&"
import style0 from "./AgreementRenderer.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AgreementRenderer.vue?vue&type=style&index=1&id=4e265570&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e265570",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
